import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'
import NProgress from 'nprogress'

import Credentials from '../Credentials';

import Notification from '../../services/Notification.js'
import Train from '../../services/train.js';
import StringUtils from '../../services/StringUtils.js';

import '../../../css/UserSettings.css';

class UserSettings extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      userId: this.props.match.params.user,
      lastfm: '',
      spotify: '',
      facebook: {},
      twitter: {},
      showPasswordResetForm: false
    }

    let spotifyScopes = [
      'user-read-private',
      'streaming',
      'user-library-read',
      'user-top-read',
      'user-read-recently-played',
      'playlist-read-collaborative',
      'playlist-read-private'
    ];

    let encodedScopes = spotifyScopes.join('%20');

    this.lastfmUserAuthorizationUrl = `http://www.last.fm/api/auth/?api_key=d51da5cb04a108c94a20b056826f34e9`;
    this.spotifyAuthorizationUrl = `https://accounts.spotify.com/authorize?client_id=d2820b2f104b41aa88634908da749318&response_type=code&show_dialog=true&scope=${encodedScopes}`;

    this.refreshCb = props.refreshCb;

  }

  componentWillReceiveProps(newProps) {
    this.refreshCb = newProps.refreshCb;
  }

  componentDidMount() {
    this.fetchData({userId: this.state.userId});
  }

  fetchData({userId}) {

    NProgress.start();

    let promises = ['lastfm', 'spotify', 'twitter', 'facebook'].map((service) => {
      return Train.userServiceData(service).then((result) => { return {service, result} });
    });

    Promise.all(promises)
    .then((results) => {
      let state = results.reduce((state, result) => {
        state[result.service] = result.result;
        return state;
      }, {});
      this.setState(state);
      NProgress.done();
    });

  }

  authorizeLastfm() {
    window.location = `${this.lastfmUserAuthorizationUrl}&cb=${window.location.origin}/authorize/lastfm`;
  }

  authorizeSpotify() {
    window.location = `${this.spotifyAuthorizationUrl}&redirect_uri=${window.location.origin}/authorize/spotify`;
  }

  authorizeFacebook() {
    const scope = {scope: ['public_profile', 'email']};
    let onLogin = (response) => {
      if (response.status === 'connected') {
        Train.authorizeFacebook({accessToken: response.authResponse})
        .then( () => {
          Notification.show('Accounts have been connected', 'success');
        })
        .catch( () => {
          Notification.show('Facebook account might be unavailable', 'error');
        });
      }
      else {
        Notification.show('Error connecting to Facebook', 'error');
      }
    };

    window.FB.login(onLogin, scope);
  }

  authorizeTwitter() {
    Train.requestTwitterAuthorization()
    .then((url) => {
      window.location = url;
    })
  }

  renderStatus(service) {

    let authorize;

    if (service === 'lastfm')
      authorize = this.authorizeLastfm.bind(this);
    else if (service === 'spotify')
      authorize = this.authorizeSpotify.bind(this);
    else if (service === 'twitter')
      authorize = this.authorizeTwitter.bind(this);
    else if (service === 'facebook')
      authorize = this.authorizeFacebook.bind(this);

    let username = this.state[service];

    if (typeof(username) === 'object') {
      username = username.username || username.name;
    }

    let renderUsername = () => {

      if (service === 'lastfm')
        return <Link to={`/lastfm-users/${username}`}><b className="clickable">{username}</b></Link>;
      else
        return <b>{username}</b>;

    };

    let syncTop = () => {
      Train.syncTop({service})
      .then(() => {
        this.refreshCb();
      })
      Notification.show(`Sync with ${service} started`, 'success');
    };

              
    let renderExtraOptions = () => {

      if (service === 'lastfm' || service === 'spotify')
        return <label>Click <b onClick={syncTop} className="clickable">here</b> to sync your top artists and tracks.</label>;
    };

    return (
      <div>
        <div>
          <i className={`fontastic icon-${service}`}></i>
          <label>{StringUtils.titleize(service)}</label>
        </div>
        <div>
          {!username && <label>You are still not connected. Click <b onClick={authorize} className="clickable" href="#">here</b> to connect.</label>}
          {username && <label>You are connected as {renderUsername()}. Click <b onClick={authorize} className="clickable" href="#">here</b> to switch user.</label>}
          {username && renderExtraOptions()}
        </div>
      </div>
    );
    
  }

  showPasswordResetForm() {
    this.setState({showPasswordResetForm: true});
  }

  hidePasswordResetForm() {
    this.setState({showPasswordResetForm: false});
  }

  render() {

    let services = ['lastfm', 'spotify', 'facebook', 'twitter'].map((service) => {

      return (
        <li key={service} className="service">
          {this.renderStatus(service)}
        </li>
      );  

    });

    return (

      <div className="userPage settings">

        <div id="accountConnections">
          <h2>Connect your account</h2>
          
          <ul>
            {services}
          </ul>
          
        </div>

        <div>
          <h2>Password</h2>
          <ul>
            <li>
              <label>Click <b onClick={this.showPasswordResetForm.bind(this)} className="clickable" href="#">here</b> to reset your password.</label>          
            </li>
          </ul>
        </div>

        <Credentials form={'password_reset'} show={this.state.showPasswordResetForm} onClose={this.hidePasswordResetForm.bind(this)}/>

      </div>

    ); 

  }
}

export default withRouter(UserSettings);



// WEBPACK FOOTER //
// ./src/js/components/user/UserSettings.jsx